import { observable, action, makeObservable } from 'mobx';

import {
    ServiceRisksData,
    DefaultServiceRisksData,
    ServiceRisksUpdateParams,
} from 'chaika-frontend-types/frontend-cms';

import { SimpleList } from '@store/models/SimpleList';
import { assertIsDefined } from '@utils/assertIsDefined';

export class ServiceRisksList extends SimpleList<ServiceRisksData> {
    @observable
    private defaultRisk?: DefaultServiceRisksData;

    constructor(params?: ServiceRisksData[]) {
        super(params);
        makeObservable(this);
    }

    @action
    public setDefaultData(params: DefaultServiceRisksData): void {
        this.defaultRisk = params;
    }

    @action
    public updateDefaultData({ risks }: ServiceRisksUpdateParams): void {
        assertIsDefined(this.defaultRisk, 'Default service risks are updated only after they are loaded');
        // @ts-ignore
        this.defaultRisk.risks = risks;
    }

    public getDefaultRisk(): string {
        return this.defaultRisk?.risks ?? '';
    }
}
